import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=0a687cf4&scoped=true&"
import script from "./Card.vue?vue&type=script&lang=tsx&"
export * from "./Card.vue?vue&type=script&lang=tsx&"
import style0 from "./Card.vue?vue&type=style&index=0&id=0a687cf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a687cf4",
  null
  
)

export default component.exports